import type { Appointment } from '@/types/scheduling';
import { toCenterTime } from '@/utils/timezone';
import { format } from 'date-fns';

export const groupAppointmentsByTime = (appointments: Appointment[], timeZone: string): { date: Date; appointments: Appointment[] }[] => {
  const groupedAppointments = new Map<string, { date: Date; appointments: Appointment[] }>();

  for (const appointment of appointments) {
    const appointmentDate = toCenterTime(appointment.appointment_date, timeZone);
    const dateKey = format(appointmentDate, 'yyyy-MM-dd hh:mm a');

    if (!groupedAppointments.has(dateKey)) {
      groupedAppointments.set(dateKey, { date: appointmentDate, appointments: [] });
    }
    groupedAppointments.get(dateKey)!.appointments.push(appointment);
  }

  return [...groupedAppointments.values()];
};
